import React from 'react';
import { Link } from 'react-router-dom';
const PageNotFound = () => {
  return (
    <div className="w-full py-4">
      <div className="bg-white p-4 rounded-2xl w-full min-h-[calc(100vh-76px-60px-32px-32px)] flex items-center justify-center">
        <div className="text-center">
          <img src="/img/404.svg" alt="" className="mx-auto mb-3" />
          <h3 className="text-3xl font-semibold mb-3">Something went wrong</h3>
          <p className="text-gray-700 mb-5">
            The page you are looking for doesn’t exits
          </p>
          <Link to="/">
            <button className="px-6 py-4 text-white bg-brandBlue rounded-lg">
              Back to Home
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
